// import { FLAG_CONSTANTS } from '@/constants'
import store from '@/store/index'
import { LOGOUT } from '@/store/modules/auth.module'
import { generateAllPossibleStepRoutes, getActiveStepFlow, guardB2bAuth } from '@/router/routes/utils'

export const AUTH_REGISTER = 'auth-register'
export const AUTH_REGISTER_V2 = 'auth-register-v2'
export const AUTH_REGISTER_CHILDREN = {
  CHOOSE_ROLE: 'choose-role',
  ADD_USER: 'add-user',
  ENTER_DETAILS: 'enter-details',
  SET_PASSWORD: 'set-password',
}

// const authGuardSignupV2 = (to, from, next) => {
//   const signupDetails = store.getters.getSignupDetails
//   if (!(signupDetails && !!signupDetails.role)) {
//     next({
//       name: AUTH_REGISTER_CHILDREN.CHOOSE_ROLE,
//       replace: true,
//     })
//   } else {
//     next()
//   }
// }
//

// Routes array starts here...
export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/apps/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/apps/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      hideForAuth: true,
    },
    beforeEnter: guardB2bAuth,
  },
  {
    path: '/sign-up',
    name: AUTH_REGISTER_V2,
    component: () => import('@/views/apps/authentication-v2/Register.vue'),
    redirect: () => {
      const firstStep = getActiveStepFlow()?.[0]?.key
      return { name: firstStep || 'misc-not-authorized' }
    },
    children: generateAllPossibleStepRoutes(),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      hideForAuth: true,
    },
    beforeEnter: guardB2bAuth,
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/apps/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      hideForAuth: true,
    },
    beforeEnter: guardB2bAuth,
  },
  {
    path: '/reset-password/:token',
    name: 'auth-reset-password-v2',
    component: () => import('@/views/apps/authentication/ResetPassword-v2.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      hideForAuth: true,
    },
  },
  // created change-password router
  {
    path: '/change-password/:token',
    name: 'auth-change-password-v2',
    component: () => import('@/views/apps/authentication/ResetPassword-v2.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      hideForAuth: true,
    },
  },
  {
    path: '/logout',
    name: 'logout',
    component: {
      beforeRouteEnter(to, from, next) {
        const destination = {
          path: from.path || '/',
          query: from.query,
          params: from.params,
        }
        store.dispatch(LOGOUT).then(() => next(destination))
      },
    },
    meta: {
      resource: 'Auth',
    },
  },
  {
    path: '/apps/miscellaneous/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/apps/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/apps/miscellaneous/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('@/views/apps/miscellaneous/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/apps/miscellaneous/error',
    name: 'misc-error',
    component: () => import('@/views/apps/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/guest-user',
    name: 'guest-user',
    component: () => import('@/views/apps/authentication/GuestLogin.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      hideForAuth: true,
      redirectIfLoggedIn: true,
    },
    beforeEnter: guardB2bAuth,
  },
  {
    path: '/wishlist/public/:publicToken',
    name: 'wishlist-public',
    component: () => import('@/views/apps/wishlist/PublicWishlist.vue'),
    meta: {
      layout: 'vertical',
      guest: true,
      pageTitle: 'Wishlist Products',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'wishlist name',
          dynamic: true,
          wishlistName: '...',
          parse: item => item.wishlistName,
          to: {
            name: 'selection',
            params: { wishlistId: '$wishlistId' },
          },
          active: true,
        },
      ],
      resource: 'Brand',
      action: 'read',
    },
  },
]
